<div class="d-flex" [formGroup]="formGroup">
    <input type="text" class="form-control location-value"
        [ngbTypeahead]="aisleSearch" [resultFormatter]="subLocFormatter" container="body"
        [inputFormatter]="subLocFormatter" [editable]="false" [disabled]="!aisles?.length"
        (focus)="emitValue($event, 0)" formControlName="aisle">
    <input type="text" class="form-control location-value" style="width: 52px;"
        [ngbTypeahead]="unitSearch" [resultFormatter]="subLocFormatter" container="body"
        [inputFormatter]="subLocFormatter" [editable]="false" formControlName="unit"
        (focus)="emitValue($event, 1)">
    <input type="text" class="form-control location-value"
        [ngbTypeahead]="shelfSearch" [resultFormatter]="subLocFormatter" container="body"
        [inputFormatter]="subLocFormatter" [editable]="false" formControlName="shelf"
        (focus)="emitValue($event, 2)">
    <input type="text" class="form-control location-value"
        [ngbTypeahead]="binSearch" [resultFormatter]="subLocFormatter" container="body"
        [inputFormatter]="subLocFormatter" [editable]="false" formControlName="bin"
        (focus)="emitValue($event, 3)">
</div>